import React from "react"
import {createBrowserRouter, Navigate} from "react-router-dom"
import ErrorPage from '../pages/ErrorPage'
import Login from "../components/layout/Auth/components/Login"
import EmployeesPage from "../pages/EmployeesPage"
import OrderDetailPage from "../pages/OrderDetailPage"
import OrderPage from "../pages/OrderPage"
import Layout from "../components/layout/Layout"
import Auth from "../components/layout/Auth"
import HandbookPage from "../pages/HandbookPage"
import ProfilePage from "../pages/ProfilePage"
import ClientDetailPage from "../pages/ClientDetailPage"
import ResetPassword from "../components/layout/Auth/components/ResetPassword/ResetPassword"

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout/>,
    errorElement: <ErrorPage/>,
    children: [
      {
        element: <Navigate to={'order/'}/>,
        index: true
      },
      {
        path: "employee/",
        element: <EmployeesPage/>,
        handle: {
          privateUrl: true
        }
      },
      {
        path: "order/",
        element: <OrderPage/>,
        handle: {
          privateUrl: true
        }
      },
      {
        path: "order/:id",
        element: <OrderDetailPage/>,
        handle: {
          privateUrl: true
        }
      },
      {
        path: "handbook/",
        element: <HandbookPage/>,
        handle: {
          privateUrl: true
        }
      },
      {
        path: "handbook/client/:client_uuid",
        element: <ClientDetailPage/>,
        handle: {
          privateUrl: true
        }
      },
      {
        path: "profile/",
        element: <ProfilePage/>,
        handle: {
          privateUrl: true
        }
      }
    ]
  },
  {
    path: "/auth",
    element: <Auth/>,
    children: [
      {
        index: true,
        element: <Navigate to={'login/'}/>
      },
      {
        path: "login/",
        element: <Login/>,
      },
      {
        path: "reset-password/",
        element: <ResetPassword/>,
      }
    ]
  }
])